const ENVS = {
    API_URL: 'https://api.distribuidoresfluke.com.br/',
}

module.exports = ENVS
